import React, { Component } from 'react'
import { default as ReactDropzone } from 'react-dropzone'
import { Alert, Icon, List } from '@softwaredev_cegeka/stix-core'
import { withNotifier } from '@softwaredev_cegeka/stix-notifier'
import { DefaultLoader } from '../loaders'
import { formatBytes, getBase64 } from '../utils/utils'
import './dropzone.scss'

// comma separated list of allowed files, we only upload to USD API for now
const DEFAULT_ACCEPTED_CONTENT_TYPES =
    'image/*, .pdf, .doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .txt'

class Dropzone extends Component {
    state = {
        listItems: [],
        convertedFiles: [],
        isUploading: false,
    }

    /**
     * Construct list of upload files and prepare data for api POST
     * Create callback with converted files if upload is used as form element
     * @param acceptedFiles
     */
    onDropHandler(acceptedFiles) {
        let convertedFiles = []
        let files =
            acceptedFiles.length === 0 ? (
                <Alert variant={'danger'}>
                    Not allowed to upload this kind of document.
                </Alert>
            ) : (
                <div className={'upload-file-list'}>
                    <h2> Attached files</h2>
                    <List>
                        {acceptedFiles.map(file => {
                            getBase64(file).then(data =>
                                convertedFiles.push({
                                    fileName: file.path,
                                    data,
                                })
                            )
                            return (
                                <List.Item
                                    key={file.path}
                                    title={file.path}
                                    description={formatBytes(file.size)}
                                />
                            )
                        })}
                    </List>
                </div>
            )

        this.setState({ listItems: files, convertedFiles: convertedFiles })
    }

    /**
     * Sends uploaded File types back (no base64)
     * @param files
     */
    handleAcceptedFiles = files => {
        if (this.props.onAcceptedFiles instanceof Function) {
            this.props.onAcceptedFiles(files)
        }
    }

    render() {
        const { allowedMimeTypes = DEFAULT_ACCEPTED_CONTENT_TYPES, name } =
            this.props
        return this.state.isUploading ? (
            <section className={'upload-container'}>
                <DefaultLoader />
            </section>
        ) : (
            <ReactDropzone
                onDrop={acceptedFiles => this.onDropHandler(acceptedFiles)}
                onDropAccepted={this.handleAcceptedFiles}
                accept={allowedMimeTypes}
            >
                {({ getRootProps, getInputProps }) => (
                    <section className={'upload-container'}>
                        <div
                            {...getRootProps({
                                className: 'dropzone',
                            })}
                        >
                            <input {...getInputProps({ name })} />
                            <p>
                                Drag 'n' drop some files here, or click to
                                select files
                            </p>
                            <Icon icon={'reports'} />
                        </div>
                        {this.state.listItems}
                    </section>
                )}
            </ReactDropzone>
        )
    }
}

export default withNotifier(Dropzone)
